
import { BaseDto } from '@/shared/dtos/base-dto';
export class VariableDto extends BaseDto {
    public clave!: string;
    public valor!: string;
}